import React from 'react'

const Blog = () => {
    return (
        <div>
            Coming Soon
        </div>
    );
};

export default Blog;